export default __webpack_public_path__ + "static/media/logo.fe652e53.png";